export const ROUTES = {
  HOME: "/",
  registrationGate: "/registration-gate",
  taxonomy: {
    preview: "/preview",
    regions: "/taxonomy/regions",
    regionCountries: "/taxonomy/region-countries",
    bpas: "/taxonomy/bpas",
    directories: "/taxonomy/directories",
    editions: "/taxonomy/editions",
    industrySectors: "/taxonomy/industry-sectors",
    miscellaneous: "/taxonomy/miscellaneous",
  },
  fulfilment: {
    features: "/fulfilment/features",
    packages: "/fulfilment/packages",
    packageDetail: (id: string) => `/fulfilment/packages/${id}`,
    subscriptions: "/fulfilment/subscriptions",
    subscriptionDetail: (id: string) => `/fulfilment/subscriptions/${id}`,
    firmDashboard: (firmId: string | number) => `/fulfilment/firms/${firmId}`,
    crmPackageMappings: "/fulfilment/crm-package-mappings",
    crmPackageMappingDetail: (id: string) => `/fulfilment/crm-package-mappings/${id}`,
    crmWebhookLogs: "/fulfilment/crm-webhook-logs",
    crmWebhookLogDetail: (id: string) => `/fulfilment/crm-webhook-logs/${id}`,
    bulkSubscriptionUpdate: "/fulfilment/bulk-subscription-update",
  },
  users: {
    website: "/users/website",
    websiteDetail: (id: string) => `/users/website/${id}`,
    regionPublications: "/users/region-publications",
    accountServices: "/users/account-services",
    staff: "/users/staff",
    detail: (id: string) => `/users/detail/${id}`,
    organisations: "/users/organisations",
    organisationNew: "/users/organisations/new",
    organisationDetail: (id: string) => `/users/organisations/${id}`,
    roles: "/users/roles",
    userVerification: "/users/user-verification",
  },
  machineAccounts: {
    list: "/users/machine-accounts",
    detail: (id: string) => `/users/machine-accounts/${id}`,
  },
  websiteUsers: {
    companies: "/website-users/companies",
    pendingCompanies: "/website-users/pending-companies",
  },
  addressBook: {
    companies: "/address-book/companies",
    companyDetail: (id: string) => `/address-book/companies/${id}`,
    companyMerge: (id: string) => `/address-book/companies/${id}/merge`,
    companyDemerge: (id: string) => `/address-book/companies/${id}/demerge`,
    contacts: "/address-book/contacts",
    contactDetail: (id: string) => `/address-book/contacts/${id}`,
    contactMerge: (id: string) => `/address-book/contacts/${id}/merge`,
    contactDemerge: (id: string) => `/address-book/contacts/${id}/demerge`,
    contactSplit: (id: string) => `/address-book/contacts/${id}/split`,
    offices: "/address-book/offices",
    officeDetail: (id: string) => `/address-book/offices/${id}`,
    officeMerge: (id: string) => `/address-book/offices/${id}/merge`,
    officeDemerge: (id: string) => `/address-book/offices/${id}/demerge`,
    companyOfficeNew: (companyId: string) => `/address-book/companies/${companyId}/offices/new`,
    companyContactNew: (companyId: string) => `/address-book/companies/${companyId}/contacts/new`,
    officeContactNew: (officeId: string) => `/address-book/offices/${officeId}/contacts/new`,
  },
  dataMarts: {
    root: "/data-marts",
    detail: (id: string) => `/data-marts/${id}`,
  },
  powerlist: {
    series: "/gc-powerlist",
    seriesDetail: (seriesId: string) => `/gc-powerlist/series/${seriesId}`,
    edition: (editionId: string) => `/gc-powerlist/editions/${editionId}`,
    preview: (editionId: string) => `/gc-powerlist/editions/${editionId}/preview`,
    newEntry: (editionId: string) => `/gc-powerlist/editions/${editionId}/entries/new`,
    entry: (editionId: string, entryId: string) =>
      `/gc-powerlist/editions/${editionId}/entries/${entryId}`,
    questions: "/gc-powerlist/questions",
  },
  awards: {
    list: "/awards",
    new: "/awards/new",
    edit: (id: string) => `/awards/${id}/edit`,
  },
  dataProducts: {
    omni: "/data-products/omni",
    omniNew: "/data-products/omni/new",
    omniDetail: (id: string) => `/data-products/omni/${id}`,
    historicalData: "/data-products/historical-data",
    historicalDataNew: "/data-products/historical-data/new",
    historicalDataDetail: (id: string) => `/data-products/historical-data/${id}`,
  },
  developer: {
    swagger: "/swagger",
    syncers: "/developer/syncers",
    queueMonitor: "/developer/queue-monitor",
    services: "/developer/services",
    featureFlags: "/developer/feature-flags",
    loadTestAccounts: "/developer/loadtest-accounts",
    notifications: "/developer/notifications",
    notificationsCapabilities: "/developer/notifications/capabilities",
    notificationsEventLog: "/developer/notifications/event-log",
    parseMonitoring: "/developer/parse-monitoring",
    editorialTransform: "/developer/editorial-transform",
    pipelineBrowser: "/developer/pipeline-browser",
    users: "/developer/users",
    accountRemediation: "/developer/account-remediation",
    crmWebhook: "/developer/crm-webhook",
    companySlugDrift: "/developer/company-slug-drift",
    websiteRelabel: "/developer/website-relabel",
    officeIdentityBackfill: "/developer/office-identity-backfill",
    officeSlugBackfill: "/developer/office-slug-backfill",
    contactSlugBackfill: "/developer/contact-slug-backfill",
    contactMatchBackfill: "/developer/contact-match-backfill",
    researchDataImport: "/developer/research-data-import",
    contactRoleEndDateBackfill: "/developer/contact-role-end-date-backfill",
    surveyTestimonialReplay: "/developer/survey-testimonial-replay",
    addressBookRenameReplay: "/developer/address-book-rename-replay",
    nameTranslationsImport: "/developer/name-translations-import",
    researchDb: "/developer/research-db",
    awardsImport: "/developer/awards/import",
    firmLogoCopy: "/developer/firm-logo-copy",
  },
  audit: {
    list: "/audit",
  },
  l500Data: {
    redisLoading: "/legal500-data/redis-loading",
    redisLoadingKeyspace: (keyspace: string, family?: string) =>
      family
        ? `/legal500-data/redis-loading/keyspaces/${keyspace}?family=${encodeURIComponent(family)}`
        : `/legal500-data/redis-loading/keyspaces/${keyspace}`,
    redisBreakdown: "/legal500-data/redis-breakdown",
    wpSyncer: "/legal500-data/wp-syncer",
    wpSyncerRun: (runId: string) => `/legal500-data/wp-syncer/runs/${runId}`,
    wpSyncerImageCache: "/legal500-data/wp-syncer/image-cache",
    promoteImpact: "/legal500-data/promote-impact",
    intelligenceSyncer: "/legal500-data/intelligence-syncer",
    bulkExternalRefs: "/legal500-data/bulk-external-references",
  },
  submissions: {
    list: "/submissions/list",
    referees: "/submissions/referees",
    documentParsing: "/submissions/document-parsing",
    documentParsingDetail: (id: string) => `/submissions/document-parsing/jobs/${id}`,
    aiSchemas: "/submissions/ai-schemas",
    aiMarkdownTemplates: "/submissions/ai-markdown-templates",
    aiParseRuns: "/submissions/ai-parse-runs",
    rollingSubmissions: "/submissions/rolling-submissions",
    rollingSubmissionCreate: "/submissions/rolling-submissions/new",
    rollingSubmissionDetail: (id: string) => `/submissions/rolling-submissions/${id}`,
  },
  marketingToolkit: {
    copyTemplates: "/marketing-toolkit/copy-templates",
    terms: "/marketing-toolkit/terms",
    downloadAudit: "/marketing-toolkit/download-audit",
    embargoTexts: "/marketing-toolkit/embargo-wording",
    userGuide: "/marketing-toolkit/user-guide",
    firmDiagnostics: "/marketing-toolkit/firm-diagnostics",
    regionMapping: "/marketing-toolkit/region-mapping",
  },
  surveys: {
    management: "/surveys/management",
    campaigns: "/surveys/campaigns",
    campaignDetail: (publicationId: string, edition: string) =>
      `/surveys/campaigns/${publicationId}/${edition}`,
    campaignGroupDetail: (publicationId: string, edition: string, groupId: string) =>
      `/surveys/campaigns/${publicationId}/${edition}/groups/${groupId}`,
    campaignDetailPage: (
      publicationId: string,
      edition: string,
      groupId: string,
      campaignId: string,
    ) => `/surveys/campaigns/${publicationId}/${edition}/groups/${groupId}/campaigns/${campaignId}`,
    campaignSendDetail: (
      publicationId: string,
      edition: string,
      groupId: string,
      campaignId: string,
      segmentId: string,
    ) =>
      `/surveys/campaigns/${publicationId}/${edition}/groups/${groupId}/campaigns/${campaignId}/sends/${segmentId}`,
    detail: (surveyId: string) => `/surveys/${surveyId}`,
    questionLibrary: "/surveys/question-library",
    randomQuestions: "/surveys/random-questions",
    responses: "/surveys/responses",
    responseDetail: (responseId: string) => `/surveys/responses/${responseId}`,
    optOuts: "/surveys/opt-outs",
    templates: "/surveys/templates",
  },
  research: {
    contentInbox: "/research/content-inbox",
    contentInboxDetail: (id: string) => `/research/content-inbox/${id}`,
    testimonials: "/research/testimonials",
    testimonialDetail: (id: string) => `/research/testimonials/${id}`,
    auditLog: "/research/audit-log",
    commentaries: "/research/commentaries",
    createCommentary: "/research/commentaries/create",
    commentariesDetail: (id: string) => `/research/commentaries/${id}`,
    statistics: "/research/statistics",
    cms: "/research/cms",
    cmsPublication: (editionId: string) => `/research/cms/${editionId}`,
    cmsBpa: (editionId: string, bpaId: string) => `/research/cms/${editionId}/bpa/${bpaId}`,
    cmsBpaImport: (editionId: string, bpaId: string) =>
      `/research/cms/${editionId}/bpa/${bpaId}/import`,
    cmsBpaImportReview: (editionId: string, bpaId: string) =>
      `/research/cms/${editionId}/bpa/${bpaId}/import/review`,
    cmsBpaSplit: (editionId: string, bpaId: string) =>
      `/research/cms/${editionId}/bpa/${bpaId}/split`,
    cmsBpaMerge: (editionId: string, bpaId: string) =>
      `/research/cms/${editionId}/bpa/${bpaId}/merge`,
    cmsOrg: (editionId: string, bpaId: string, companyUuid: string) =>
      `/research/cms/${editionId}/bpa/${bpaId}/org/${companyUuid}`,
    cmsIndividual: (editionId: string, bpaId: string, contactUuid: string) =>
      `/research/cms/${editionId}/bpa/${bpaId}/individual/${contactUuid}`,
    cmsRankingTable: (editionId: string, bpaId: string, rankingTableId: string) =>
      `/research/cms/${editionId}/bpa/${bpaId}/ranking-table/${rankingTableId}`,
    cmsManage: (id: string, editionConfigId?: string | null) =>
      editionConfigId
        ? `/research/publications/${id}/manage?edition=${editionConfigId}`
        : `/research/publications/${id}/manage`,
    cmsCreateBpa: (id: string, editionConfigId: string) =>
      `/research/publications/${id}/create-bpa?edition=${editionConfigId}`,
    cmsEditBpa: (id: string, bpaId: string, editionConfigId: string) =>
      `/research/publications/${id}/edit-bpa/${bpaId}?edition=${editionConfigId}`,
  },
  /**
   * Events Media admin (DEV-2878). Deliberately not feature-flagged — the public page is,
   * so Events Media can prepare the catalogue and banner before launch (design D9).
   */
  events: {
    list: "/events",
    heroBanner: "/events/hero-banner",
  },
  cms: {
    homepage: "/cms/homepage",
    pages: "/cms/pages",
    pageDetail: (id: string) => `/cms/pages/${id}`,
    pageNew: "/cms/pages/new",
    pageContent: "/cms/page-content",
    menus: "/cms/menus",
  },
  account: {
    me: "/me",
  },
  gatewayAllowlist: {
    list: "/platform/gateway-allowlist",
  },
  profiles: {
    dashboard: "/profiles/dashboard",
    audit: "/profiles/audit",
    contentMoves: "/profiles/content-moves",
    userGuide: "/profiles/user-guide",
    firms: "/profiles/firms",
    firmDetail: (companyId: string) => `/profiles/firms/${companyId}`,
    articles: "/profiles/articles",
    articleDetail: (id: string) => `/profiles/articles/${id}`,
    articleNew: "/profiles/articles/new",
    firmTabs: "/profiles/firm-tabs",
    firmTabKindList: (kind: string) => `/profiles/firm-tabs/${kind}`,
    firmTabDetail: (kind: string, id: string) => `/profiles/firm-tabs/${kind}/${id}`,
    firmTabNew: (kind: string) => `/profiles/firm-tabs/${kind}/new`,
    lawyerProfiles: "/profiles/lawyer-profiles",
    lawyerProfileDetail: (id: string) => `/profiles/lawyer-profiles/${id}`,
    lawyerProfileNew: "/profiles/lawyer-profiles/new",
    firmProfiles: "/profiles/firm-profiles",
    firmProfileDetail: (id: string) => `/profiles/firm-profiles/${id}`,
    firmProfileNew: "/profiles/firm-profiles/new",
    teamPages: "/profiles/team-pages",
    teamPageDetail: (id: string) => `/profiles/team-pages/${id}`,
    teamPageNew: "/profiles/team-pages/new",
  },
};
